import { SectionCard, MiniStat } from "../shared";
import CatalogRulesEditor from "./CatalogRulesEditor";
import { Package, ExternalLink } from "lucide-react";

// ─────────────────────────────────────────────────────────────────────────
// Section 3 — Catalog mirror
// ─────────────────────────────────────────────────────────────────────────
export default function CatalogMirrorAggregateSection({ productsCount, lastSync }) {
  return (
    <SectionCard
      icon={Package}
      title="Step 3 · Catalog mirror"
      subtitle="Only products flagged as Dropship (or Both) in your Catalog app auto-mirror to buyers with the pricing rules above. Wholesale-only SKUs stay hidden from the dropship flow."
      testId="setup-section-catalog-mirror"
      defaultOpen={false}
      right={
        <a href="/seller/catalog" className="text-[11.5px] mono uppercase tracking-[0.14em] rounded-full h-8 px-3 border border-border hover:bg-secondary/50 inline-flex items-center gap-1.5">
          <ExternalLink className="w-3 h-3"/> Open Catalog app
        </a>
      }
    >
      <div className="grid grid-cols-3 gap-4 p-5">
        <MiniStat label="Products mirrored" value={productsCount ?? "—"} hint="From Catalog app" />
        <MiniStat label="Last sync"         value={lastSync ?? "—"}      hint="Auto-updates on change" />
        <MiniStat label="Global exclusions" value="See rules below"      hint="Stock + region gates" />
      </div>
      <CatalogRulesEditor />
    </SectionCard>
  );
}
